import {
  Box,
  Button,
  Typography,
  Container,
  Paper,
  Stack,
  Alert,
  Snackbar,
} from "@mui/material";

// src/components/DashboardLayout.js
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { Breadcrumb } from "react-bootstrap";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { encryptData } from "../Common/encryptionUtils";
import Shimmer from "../Common/Shimmer";
import "./UserCheckInOut.css";
import { AccessLog } from "../../Utils/AccessLog";
import CryptoJS from "crypto-js";
const secretKey = "BusinessTimeWebKiosk";

const UserCheckInOut = () => {
  const location = useLocation();
  const userId = location.state?.user_id;

  const premiseData = location.state?.premiseData;

  const [loading, setLoading] = useState(false);
  console.log("premiseData123--->", premiseData);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const captureSectionRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(120);
  const [capturedImage, setCapturedImage] = useState(null);
  const [isCheckedIn, setIsCheckedIn] = useState(null);
  const [staffStatus, setStaffStatus] = useState(null);
  const [cameraError, setCameraError] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [breakData, setBreakData] = useState(null);

  const [emitterData, setEmitterData] = useState(null);

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const formatBreakHours = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return "";

    const [hours, minutes, seconds] = timeStr
      .replace(" hrs", "")
      .split(":")
      .map(Number);

    // Handle special case for 24:00:00
    const h = hours === 24 && minutes === 0 && seconds === 0 ? 24 : hours;

    return (
      <>
        {h > 0 && (
          <>
            <span style={{ fontSize: "23px", fontWeight: "bold" }}>{h}</span>
            <span style={{ fontSize: "18px", marginRight: "8px" }}>h</span>
          </>
        )}
        {minutes > 0 || h === 0 ? (
          <>
            <span style={{ fontSize: "23px", fontWeight: "bold" }}>
              {minutes}
            </span>
            <span style={{ fontSize: "18px" }}>m</span>
          </>
        ) : null}
      </>
    );
  };

  const [searchTerm, setSearchTerm] = useState(""); // New state for search term

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update the search term as user types
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
    }
  };

  const fullName = `${userData?.user_details?.staff_first_name || ""} ${
    userData?.user_details?.staff_last_name || ""
  }`.trim();

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const currentTime = new Date().toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  // const startCamera = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     if (videoRef.current) videoRef.current.srcObject = stream;
  //     setCameraError(false);
  //   } catch (err) {
  //     console.error("Camera error:", err);
  //     setCameraError(true);
  //   }
  // };

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        // When video is ready to play
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play();
        };

        videoRef.current.onplaying = () => {
          // Delay to let layout settle, then scroll
          setTimeout(() => {
            if (captureSectionRef.current) {
              captureSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }, 300); // Adjust delay if needed
        };
      }

      setCameraError(false);
    } catch (err) {
      console.error("Camera error:", err);
      setCameraError(true);
    }
  };

  const stopCamera = () => {
    const video = document.querySelector("video");
    const stream = video?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      video.srcObject = null;
    }
  };

  useEffect(() => {
    if (premiseData[0]?.kiosk_image_capture_enabled == "true") {
      startCamera();
      return () => {
        const stream = videoRef.current?.srcObject;
        stream?.getTracks().forEach((track) => track.stop());
      };
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      localStorage.removeItem("verificationPasscodeToken");
      window.location.href = "/users";

      return;
    }
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft, navigate]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleCapture = async () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;

    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Add text overlays
    context.fillStyle = "white";
    context.font = "24px Arial";
    context.fillText(`${fullName}`, 20, 40);
    context.fillText(`${currentDate}`, 20, 80);
    context.fillText(`${currentTime}`, 20, 120);

    let quality = 1.0; // Start with highest
    let dataURL = canvas.toDataURL("image/jpeg", quality);
    let blob = await (await fetch(dataURL)).blob();

    // Reduce quality until size < 256 KB
    while (blob.size > 256 * 1024 && quality > 0.1) {
      quality -= 0.05;
      dataURL = canvas.toDataURL("image/jpeg", quality);
      blob = await (await fetch(dataURL)).blob();
    }

    const file = new File([blob], "capture.jpg", { type: "image/jpeg" });
    setCapturedImage(file); // Set the compressed image

    console.log("Final image size:", (file.size / 1024).toFixed(2), "KB");
  };

  // const handleCapture = () => {
  //   const canvas = canvasRef.current;
  //   const video = videoRef.current;
  //   if (!canvas || !video) return;

  //   const context = canvas.getContext("2d");
  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   context.drawImage(video, 0, 0, canvas.width, canvas.height);

  //   context.fillStyle = "white";
  //   context.font = "24px Arial";
  //   context.fillText(`${fullName}`, 20, 40);
  //   context.fillText(`${currentDate}`, 20, 80);
  //   context.fillText(`${currentTime}`, 20, 120);

  //   // Convert canvas to dataURL
  //   const dataURL = canvas.toDataURL("image/png");

  //   // Convert dataURL to Blob
  //   fetch(dataURL)
  //     .then((res) => res.blob())
  //     .then((blob) => {
  //       const file = new File([blob], "capture.png", { type: "image/png" });
  //       setCapturedImage(file); // Set captured image as File object
  //       console.log("Image size in bytes:", file.size);
  //       console.log("Image size in KB:", (file.size / 1024).toFixed(2) + " KB");
  //     });
  // };

  const handleCheckIn = () => {
    if (!capturedImage) return;
    setLoading(true);
    localStorage.setItem("checkin_image", capturedImage);
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    // Assuming capturedImage is the File object you got from input/camera
    userCheckInOut(selectedPremise?.value, capturedImage, "in");
  };

  const handleCheckOut = () => {
    if (!capturedImage) return;
    setLoading(true);
    localStorage.setItem("checkout_image", capturedImage); // Optional: save checkout image
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    // Call API with checkout status
    userCheckInOut(selectedPremise?.value, capturedImage, "out");
  };

  const handleAcceptBreak = () => {
    if (!capturedImage) return;
    setLoading(true);
    localStorage.setItem("checkin_image", capturedImage);
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    // Assuming capturedImage is the File object you got from input/camera
    acceptBreak(selectedPremise?.value, capturedImage);
  };

  const handleRetake = () => {
    setCapturedImage(null);
    startCamera();
  };

  const authToken = localStorage.getItem("authToken");

  const fetchUserDetails = async (premise_id) => {
    try {
      const currentDate = new Date().toLocaleDateString("en-CA");

      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getDashboardData?premise_id=${encryptData(
          premise_id?.toString()
        )}&date=${encryptData(currentDate?.toString())}&user_id=${encryptData(
          userId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setUserData(user_details);
        console.log("user_detailsDate--->", user_details);
        setIsCheckedIn(user_details?.staff_last_status);
        setStaffStatus(user_details?.user_details?.staff_status);
      } else {
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  const getCurrentActiveBreakDetails = async (premise_id) => {
    try {
      const currentDate = new Date().toLocaleDateString("en-CA");
      // const currentDate = "2025-05-25";

      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const response = await apiRequest(
        `web_api/admin/getCurrentActiveBreakDetails?premise_id=${encryptData(
          premise_id?.toString()
        )}&date=${encryptData(currentDate?.toString())}&user_id=${encryptData(
          userId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (response?.data?.status_code === 200 && response?.data?.data) {
        const break_details = response.data?.data;
        if (break_details && Object.keys(break_details).length > 0) {
          setBreakData(break_details);
          if (
            break_details?.event === "unpaid_break_started" ||
            break_details?.event === "paid_break_started"
          ) {
            toast.info("You are currently on a break!", {
              position: "top-right",
              autoClose: 6000,
            });
          }
        } else {
          const event = "";
          setBreakData({ event });
        }
      } else {
        console.error(
          "Error: Invalid status code",
          response?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchEmiiterDetails = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const response = await apiRequest(
        `api/user/getemittersdetailsPremiseid?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (response?.data?.status_code === 200 && response?.data?.data) {
        console.log("emitter_details-->", response.data?.data);
        const emitter_details = response.data?.data;
        if (emitter_details && Object.keys(emitter_details).length > 0) {
          setButtonsDisabled(false);
          setEmitterData(emitter_details);
        } else {
          setButtonsDisabled(true);
          toast.info(
            "No sensor details found for this premise. Please contact the admin.",
            {
              position: "top-right",
              autoClose: 6000,
            }
          );
          console.log("NoData-->", emitter_details);
        }
      } else {
        console.error(
          "Error: Invalid status code",
          response?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const userCheckInOut = async (premise_id, capturedImage, status) => {
    if (!capturedImage) {
      toast.error("Image is required.", {
        position: "top-right",
        autoClose: 4000,
      });
      return;
    }

    try {
      setButtonsDisabled(true);
      const formData = new FormData();

      // ⬇️ Append the image (MANDATORY)
      formData.append("capture_image", capturedImage);

      // ⬇️ Append all required fields (encrypted and static)
      formData.append("manual_type", encryptData("manual-sensor"));
      formData.append("premise_id", encryptData(premise_id?.toString()));
      formData.append(
        "emitters_id",
        encryptData(emitterData?.emitters_id?.toString())
      );
      formData.append("status", encryptData(status));
      formData.append("distance", "cTFhQjM3NkZSZTJKeTFBSys5a1VUQT09");
      formData.append("reserved", "M1JmMGtuZVExakduUGhmWnlJTVpGUT09");
      formData.append("device_type", "android");
      formData.append(
        "user_id",
        encryptData(userData?.user_details?.staff_id?.toString())
      );

      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      };

      const response = await apiRequest(
        `api/user/insertManualCheckinCheckout`,
        "POST",
        formData,
        headers
      );

      if (response?.data?.status_code === 200 && response?.data?.data) {
        const emitter_details = response.data?.data;
        // await fetchUserDetails(selectedPremise?.value);
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setTimeout(() => {
          localStorage.removeItem("verificationPasscodeToken");
          window.location.href = "/users";
        }, 3000);
      } else {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setTimeout(() => {
          localStorage.removeItem("verificationPasscodeToken");
          window.location.href = "/users";
        }, 3000);
        console.error(
          "Error: Invalid status code",
          response?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error submitting check-in/out:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      // ✅ Reset everything
      localStorage.removeItem("checkin_image");
      setCapturedImage(null);
      if (premiseData[0]?.kiosk_image_capture_enabled == "true") {
        startCamera();
      }
      setLoading(false);
    }
  };

  const acceptBreak = async (premise_id, capturedImage) => {
    if (!capturedImage) {
      toast.error("Image is required.", {
        position: "top-right",
        autoClose: 4000,
      });
      return;
    }

    try {
      setButtonsDisabled(true);
      const formData = new FormData();

      // ⬇️ Append the image (MANDATORY)
      formData.append("capture_image", capturedImage);
      formData.append("premise_id", encryptData(premise_id?.toString()));
      formData.append(
        "rules_and_alerts_rule_notification_data_id",
        encryptData(
          breakData?.rules_and_alerts_rule_notification_data_id?.toString()
        )
      );
      formData.append("status", encryptData("accepted"));
      formData.append(
        "user_id",
        encryptData(userData?.user_details?.staff_id?.toString())
      );

      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      };

      const response = await apiRequest(
        `api/user/insertNotificationStatus`,
        "POST",
        formData,
        headers
      );

      if (response?.data?.status_code === 200 && response?.data?.data) {
        const emitter_details = response.data?.data;
        // await fetchUserDetails(selectedPremise?.value);
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setTimeout(() => {
          localStorage.removeItem("verificationPasscodeToken");
          window.location.href = "/users";
        }, 3000);
      } else {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setTimeout(() => {
          localStorage.removeItem("verificationPasscodeToken");
          window.location.href = "/users";
        }, 3000);
        console.error(
          "Error: Invalid status code",
          response?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error submitting check-in/out:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      // ✅ Reset everything
      localStorage.removeItem("checkin_image");
      setCapturedImage(null);
      if (premiseData[0]?.kiosk_image_capture_enabled == "true") {
        startCamera();
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchUserDetails(selectedPremise?.value);
    getCurrentActiveBreakDetails(selectedPremise?.value);
    fetchEmiiterDetails(selectedPremise?.value);

    const stored = localStorage.getItem("verificationPasscodeToken");
    console.log("stored--->", stored);
    if (stored) {
      const bytes = CryptoJS.AES.decrypt(stored, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      console.log("decrypted--->", decrypted);
      if (decrypted !== "verifiedPasscode:true") {
        window.location.href = "/users";
        localStorage.removeItem("verificationPasscodeToken");
      }
    } else {
      window.location.href = "/users";
    }

    if (premiseData[0]?.kiosk_image_capture_enabled == "false") {
      setCapturedImage(true);
    }
  }, []);

  console.log("capturedImage123--->", capturedImage);

  const handleBackButton = () => {
    localStorage.removeItem("verificationPasscodeToken");
    window.location.href = "/users";
  };

  console.log("emitterData--->", emitterData);

  useEffect(() => {
    if (captureSectionRef.current) {
      console.log("Caturee");
      captureSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, []);

  console.log("breakData--->", breakData);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="row mt-0 mb-0 g-4">
                <div className="row">
                  <div className="col-6">
                    <i
                      className="fa fa-long-arrow-left backIcon"
                      aria-hidden="true"
                      onClick={handleBackButton}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                </div>
                <Container sx={{ mb: 3, marginTop: "5px" }}>
                  <Paper elevation={6} sx={{ borderRadius: 4, p: 3 }}>
                    {/* existing header stack */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                      mb={3}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          minWidth: 0,
                          wordBreak: "break-word", // this enables name wrapping
                          flex: 1, // allows it to take available space
                        }}
                      >
                        {fullName}
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {currentDate}
                      </Typography>

                      <Typography
                        variant="h6"
                        color="error"
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        ⏳ {formatTime(timeLeft)}
                      </Typography>
                    </Stack>
                    {premiseData[0]?.kiosk_image_capture_enabled == "true" && (
                      <Box
                        sx={{
                          borderRadius: 3,
                          overflow: "hidden",
                          mb: 2,
                          boxShadow: 3,
                        }}
                      >
                        {capturedImage ? (
                          <img
                            src={
                              capturedImage
                                ? URL.createObjectURL(capturedImage)
                                : ""
                            }
                            alt="Captured"
                            style={{
                              width: "100%",
                              maxWidth: "480px",
                              maxHeight: "60vh",
                              objectFit: "cover",
                              borderRadius: "8px",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        ) : cameraError ? (
                          <Box p={3} textAlign="center" color="red">
                            <Typography variant="body1">
                              Unable to access camera. Please allow permission.
                            </Typography>
                          </Box>
                        ) : (
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            style={{
                              width: "100%",
                              maxWidth: "480px",
                              maxHeight: "60vh",
                              objectFit: "cover",
                              borderRadius: "8px",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        )}
                        <canvas ref={canvasRef} style={{ display: "none" }} />
                      </Box>
                    )}

                    {/* Add your hours detail boxes here */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                        mb: 3,
                        flexWrap: "wrap",
                      }}
                    >
                      <Box textAlign="center">
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color="primary"
                        >
                          {formatBreakHours(
                            userData?.donut_details?.total_in_offsite_hours
                          )}
                        </Typography>
                        <Typography variant="body2" fontWeight="bold">
                          In Hours
                        </Typography>
                      </Box>
                      <Box textAlign="center">
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color="secondary"
                        >
                          {formatBreakHours(
                            userData?.donut_details?.total_unpaidbreak_hours
                          )}
                        </Typography>
                        <Typography variant="body2" fontWeight="bold">
                          Break Hours
                        </Typography>
                      </Box>
                    </Box>
                    <Box ref={captureSectionRef}>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {/* Buttons code unchanged */}
                        {premiseData[0]?.kiosk_image_capture_enabled ==
                          "true" && (
                          <>
                            {!capturedImage && !cameraError && (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleCapture}
                                startIcon={<i className="fas fa-camera"></i>}
                                disabled={buttonsDisabled}
                              >
                                Capture Photo
                              </Button>
                            )}

                            {capturedImage && (
                              <Button
                                variant="outlined"
                                color="warning"
                                onClick={handleRetake}
                                startIcon={<i className="fas fa-sync-alt"></i>}
                                disabled={buttonsDisabled}
                              >
                                Retake
                              </Button>
                            )}
                          </>
                        )}

                        {isCheckedIn === "" ||
                        isCheckedIn === "out" ||
                        isCheckedIn === "unpaid_break_ended" ||
                        isCheckedIn === "unpaid_break_started" ? (
                          <Button
                            variant="contained"
                            color="success"
                            onClick={handleCheckIn}
                            startIcon={<i className="fas fa-check"></i>}
                            disabled={
                              !capturedImage ||
                              isCheckedIn === "unpaid_break_started" ||
                              isCheckedIn === "paid_break_started"
                            }
                          >
                            Check In
                          </Button>
                        ) : (isCheckedIn === "paid_break_ended" &&
                            staffStatus === "in") ||
                          staffStatus === "in" ||
                          breakData?.event === "paid_break_ended" ? (
                          <Button
                            variant="contained"
                            color="error"
                            onClick={handleCheckOut}
                            startIcon={<i className="fas fa-sign-out-alt"></i>}
                            disabled={!capturedImage}
                          >
                            Check Out
                          </Button>
                        ) : null}

                        {breakData?.event === "" ||
                        breakData?.event === "sent" ||
                        breakData?.event === "delivered" ||
                        breakData?.event === "expired" ||
                        breakData?.event === "opened" ? (
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={handleAcceptBreak}
                            startIcon={<i className="fas fa-coffee"></i>}
                            disabled={
                              !capturedImage ||
                              breakData?.event === "" ||
                              breakData?.event === "expired"
                            }
                            style={{ marginLeft: "1rem" }}
                          >
                            Start Break
                          </Button>
                        ) : null}

                        {/* {isCheckedIn === "paid_break_started" ||
                        isCheckedIn === "unpaid_break_started" ? (
                          <Button
                            variant="contained"
                            color="info"
                            // onClick={handleEndBreak}
                            startIcon={<i className="fas fa-play-circle"></i>}
                            disabled={!capturedImage}
                            style={{ marginLeft: "1rem" }}
                          >
                            End Break
                          </Button>
                        ) : null} */}
                      </Stack>
                    </Box>
                  </Paper>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCheckInOut;
